export class SearchInput {
  inputText: string;
}
